import { Injectable } from '@angular/core';
import * as $ from 'jquery';

interface DialogData {
  width?: number;
  height?: number;
  autoHide?: boolean;
  time?: number;
  zIndex?: number;
  hasMask?: boolean;
  confirmValue?: string;
  confirm?: Function;
  cancelValue?: string;
  cancel?: Function;
  title?: string;
  content?: string;
  type?: string;
}
@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor() {}
  default: DialogData = {
    width: 0,
    height: 0,
    autoHide: false,
    time: 1000,
    zIndex: 9999,
    hasMask: false,
    confirmValue: '确定',
    confirm: () => {},
    cancelValue: '取消',
    cancel: () => {},
    title: '',
    content: '',
    type: 'success',
  };
  settings: DialogData;
  dialogType = '';
  icons = {
    success: './assets/images/layout/success.png',
    error: './assets/images/layout/error.png',
    warning: './assets/images/layout/warning.png',
  };
  firstTime;
  secondTime;
  message = {
    success: (content: string, options?: DialogData) => {
      /*根据项目需求，message类型的弹框默认为1s自动消失，如有更改请重置覆盖*/
      if (!options) {
        options = { autoHide: true };
      } else if (Object.prototype.toString.call(options) === '[object Object]') {
        options.autoHide = true;
      }
      this.init('message', 'success', { content }, options);
    },
    error: (content: string, options?: DialogData) => {
      /*根据项目需求，message类型的弹框默认为1s自动消失，如有更改请重置覆盖*/
      if (!options) {
        options = { autoHide: true };
      } else if (Object.prototype.toString.call(options) === '[object Object]') {
        options.autoHide = true;
      }
      this.init('message', 'error', { content }, options);
    },
  };
  notification = {
    success: (title: string, content: string, options?: DialogData) => {
      /*根据项目需求，notification类型的弹框默认为5s自动消失，如有更改请重置覆盖*/
      if (!options) {
        options = { autoHide: true, time: 5000 };
      } else if (Object.prototype.toString.call(options) === '[object Object]') {
        options.autoHide = true;
        options.time = 5000;
      }
      this.init('notification', 'success', { title, content }, options);
    },
    warning: (title: string, content: string, options?: DialogData) => {
      /*根据项目需求，notification类型的弹框默认为5s自动消失，如有更改请重置覆盖*/
      if (!options) {
        options = { autoHide: true, time: 5000 };
      } else if (Object.prototype.toString.call(options) === '[object Object]') {
        options.autoHide = true;
        options.time = 5000;
      }
      this.init('notification', 'warning', { title, content }, options);
    },
    error: (title: string, content: string, options?: DialogData) => {
      /*根据项目需求，notification类型的弹框默认为5s自动消失，如有更改请重置覆盖*/
      if (!options) {
        options = { autoHide: true, time: 5000 };
      } else if (Object.prototype.toString.call(options) === '[object Object]') {
        options.autoHide = true;
        options.time = 5000;
      }
      this.init('notification', 'error', { title, content }, options);
    },
  };
  modal = {
    confirm: (title: string, content: string, options?: DialogData) => {
      /*根据项目需求，modal类型的弹框都加遮罩*/
      if (!options) {
        options = { hasMask: true };
      } else if (Object.prototype.toString.call(options) === '[object Object]') {
        options.hasMask = true;
      }
      this.init('modal', 'confrim', { title, content }, options);
    },
  };
  // 初始化数据
  init(dialogType, type, initParams, options) {
    if (!this.isShow()) {
      return;
    }
    this.dialogType = dialogType;
    if (options instanceof Object) {
      options.type = type;
    } else {
      options = { type };
    }
    this.settings = {};
    $.extend(this.settings, this.default, options, initParams);
    this.initDialog();
  }
  // 初始化弹出框
  initDialog() {
    if ($('.dialog-box')) {
      this.hide();
    }
    this.render();
    this.setStyle();
    this.show();
    this.trigger();
  }
  // 渲染弹出框
  render() {
    const $body = $('body');
    $body.append(this.createElement());
    if (this.settings.hasMask) {
      $body.append('<div id="dialog-box-mask"></div>');
    }
  }
  // 创建DOM元素
  createElement() {
    let dialogHTML;
    switch (this.dialogType) {
      case 'message':
        dialogHTML = '<section class="effect-fade dialog-box"><div class="message-wrapper"><img src=' + this.icons[this.settings.type] + ' alt=""><span class="tip-text">' + this.settings.content + '</span></div></section>';
        break;
      case 'notification':
        dialogHTML = '<section class="effect-fade dialog-box"><div class="notification-wrapper"><div class="title"><img src=' + this.icons[this.settings.type] + ' alt=""><span class="tip-text">' + this.settings.title + '</span></div><div class="content">' + this.settings.content + '</div></div></section>';
        break;
      case 'modal':
        dialogHTML = '<section class="effect-fade dialog-box-confirm"><div class="modal-wrapper"><div class="title"><img src=' + this.icons.warning + ' alt=""><span class="tip-text">' + this.settings.title + '</span></div><div class="content">' + this.settings.content + '</div><div class="btns-box"><a class="btn-item btn-ok">' + this.settings.confirmValue + '</a><a class="btn-item btn-cancel-confirm">' + this.settings.cancelValue + '</a></div></div></section>';
        break;
      default:
        break;
    }
    return dialogHTML;
  }
  // 设置弹出框样式
  setStyle() {
    if (this.dialogType === 'message' || this.dialogType === 'modal') {
      const $domEl = this.dialogType === 'message' ? $('.dialog-box') : $('.dialog-box-confirm');
      $domEl.css({
        width: () => {
          if (this.settings.width) {
            return this.settings.width + 'px';
          } else {
            return;
          }
        },
        height: () => {
          if (this.settings.height) {
            return this.settings.height + 'px';
          } else {
            return;
          }
        },
        top: '50%',
        left: '50%',
        'margin-top'() {
          return -Math.round($(this).height() / 2) + 'px';
        },
        'margin-left'() {
          return -Math.round($(this).width() / 2) + 'px';
        },
        'z-index': this.settings.zIndex,
      });
    } else {
      $('.dialog-box').css({
        width: () => {
          if (this.settings.width) {
            return this.settings.width + 'px';
          } else {
            return;
          }
        },
        height: () => {
          if (this.settings.height) {
            return this.settings.height + 'px';
          } else {
            return;
          }
        },
        top: '20px',
        right: '20px',
        'margin-top': '0',
        'margin-left': '0',
        'z-index': this.settings.zIndex,
      });
    }

    if (this.settings.hasMask) {
      $('#dialog-box-mask').css({
        height: $(document).height() + 'px',
      });
    }
  }
  // 显示弹出框
  show() {
    const $dialog = this.dialogType === 'modal' ? $('.dialog-box-confirm') : $('.dialog-box');
    $dialog.css({
      display: 'block',
    });
    setTimeout(function() {
      $dialog.addClass('dialog-show');
    }, 50);
    if (this.settings.hasMask) {
      $('#dialog-box-mask').show();
    }
  }
  // 隐藏弹出框
  hide() {
    $('.dialog-box').remove();
  }
  hideConfirm() {
    $('.dialog-box-confirm').remove();
    $('#dialog-box-mask').remove();
  }
  // 弹出框事件绑定
  trigger() {
    $(document).keyup(event => {
      if (event.keyCode === 27) {
        this.hide();
      }
    });
    if (this.settings.autoHide) {
      const timeoutIns = setTimeout(() => {
        this.hide();
        clearTimeout(timeoutIns);
      }, this.settings.time);
    }
    if ($.isFunction(this.settings.confirm)) {
      $('.btn-ok').on('click', () => {
        this.settings.confirm();
        this.hide();
        this.hideConfirm();
      });
    }
    $('.btn-cancel').on('click', () => {
      this.hide();
    });
    $('.btn-cancel-confirm').on('click', () => {
      this.hideConfirm();
    });
    if ($.isFunction(this.settings.cancel)) {
      $('.btn-cancel').on('click', () => {
        this.settings.cancel();
      });
      $('.btn-cancel-confirm').on('click', () => {
        this.settings.cancel();
        this.hideConfirm();
      });
    }
  }
  isShow() {
    let flag = true;
    const nowTime = new Date().getTime();
    if (this.firstTime && nowTime - this.firstTime < 1000) {
      flag = false;
    }
    this.firstTime = nowTime;
    return flag;
  }
}
